'use strict'

var number = require('./number')

module.exports = function(value){
    return number(value) && (value === parseFloat(value, 10)) && !(value === parseInt(value, 10))
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/i-s/src/float.js
 ** module id = 855
 ** module chunks = 0
 **/